export default "__VITE_ASSET__8151cd85__"